const getBaseHref = (href) => {
    if(href && href.indexOf('//') > -1){
        const pathArray = href.split( '/' );
        return pathArray[0] + '//' + pathArray[2];
    }else{
        return '#';
    }
}

export default getBaseHref;